'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const useGoogleAnalytics = (measurementId: string): void => {
  useEffect(() => {
    if (typeof window === 'undefined' || !measurementId) return;

    // Initialize Google Analytics
    (function (
      w: Window & { [key: string]: any },
      d: Document,
      s: string,
      l: string,
      i: string
    ) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s) as HTMLScriptElement;
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtag/js?id=${i}`;
      f.parentNode?.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', measurementId);

    // Initialize gtag
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    // Set the measurement ID
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      page_path: window.location.pathname,
    });
  }, [measurementId]);
};

export default useGoogleAnalytics;
